// Resolve stored file URLs for display/download.
// Uploaded files are stored with a server-relative path (/uploads/...) that must
// be resolved against the API origin — resolving against the frontend origin
// (immt.nexedu.ma) breaks previews and downloads.
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000'}`;

export const getFullFileUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    return `${API_BASE_URL}${url}`;
  }
  return url;
};

/**
 * URL that makes the browser SAVE the file instead of opening it: the API
 * serves /uploads/... with "Content-Disposition: attachment" when
 * ?download=true is present. The HTML `download` attribute alone is ignored
 * for a cross-origin file (the API lives on another host), which is why
 * "Télécharger" used to open the PDF in a tab.
 */
export const getDownloadFileUrl = (url: string | null | undefined): string => {
  const full = getFullFileUrl(url);
  if (!full || full.startsWith('data:') || full.startsWith('blob:')) return full;
  if (!full.includes('/uploads/')) return full;
  return `${full}${full.includes('?') ? '&' : '?'}download=true`;
};
